var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85305e-06 29L3.0646 32.157L19.8 15.4216L19.8 54L24.2 54L24.2 15.4216L40.8892 32.1108L44 29C35.9458 20.9458 29.7088 14.7088 22 7C13.2748 15.7252 19.4348 9.5652 2.85305e-06 29Z",
    fill: "#3E5660"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 4,
    fill: "#3E5660"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-up.27d7d37c01db7bf47ce64a72e3b72a8a.svg";